export const NO_DATA = 'NO DATA';

export enum SwitchToImmediateChargingReason {
    ALL_DELETED,
    ALL_DISABLED,
}
